class AccordionComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const accordionTabs = this.querySelectorAll('.accordion-tab');

    accordionTabs.forEach((tab) => {
      const header = tab.querySelector('.accordion__title')?.parentElement;
      const content = tab.querySelector('.accordion__content');

      if (!header || !content) return;

      header.style.cursor = 'pointer';

      tab.addEventListener('click', () => {
        const isOpen = tab.hasAttribute('open');

        // Optionally close all others
        this.querySelectorAll('.accordion-tab').forEach((el) => {
          el.removeAttribute('open');
          const c = el.querySelector('.accordion__content');
          if (c) {
            c.style.maxHeight = '0';
            c.style.padding = '0';
          }
        });

        if (!isOpen) {
          tab.setAttribute('open', '');
          content.style.maxHeight = content.scrollHeight + 'px';

          content.addEventListener(
            'transitionend',
            () => {
              if (tab.hasAttribute('open')) {
                content.style.maxHeight = 'none';
              }
            },
            {once: true},
          );
        }
      });
      // Initialize content state
      if (tab.hasAttribute('open')) {
        content.style.maxHeight = 'none';
      } else {
        content.style.maxHeight = '0';
        content.style.padding = '0';
      }
    });
  }
}
if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}
